export function getRedirectRoute(): string {
    const params: URLSearchParams = new URLSearchParams(window.location.search)
    const redirect: string = params.get("redirect")
    return redirect || process.env.REACT_APP_PLATFORM_LANDING
}
